import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleError } from ".";
import AppService from "../../services/appService";
import { startLoad, setError, stopLoad } from "../loadingActions";

export const getAllAdmins = createAsyncThunk(
  "app/getAdmins",
  async (_, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await AppService.getAllAdmins();
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);

export const uploadFile = createAsyncThunk(
  "app/upload",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await AppService.uploadFile(data);
      return res;
    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
export const exportAsCSV = createAsyncThunk(
  "app/export",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await AppService.exportCSV(data);
      console.log(typeof res)      
      return res;

    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);


export const getCompanyReviews = createAsyncThunk(
  "app/review",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await AppService.GetCompanyReviews(data);
      console.log(typeof res)      
      return res;

    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
export const replyReviews = createAsyncThunk(
  "app/review",
  async (data, { dispatch }) => {
    dispatch(startLoad());
    try {
      const res = await AppService.ReplyReviews(data);
      console.log(typeof res)      
      return res;

    } catch (err) {
      handleError(err, dispatch);
    } finally {
      // stop loading eventually
      dispatch(stopLoad());
    }
  }
);
